/**
 * bootstrap-datepickerのメッセージ管理を行う.
 *
 * @author Nakagawa_Michio@ogis-ri.co.jp
 *
 */
switch ($('html').attr('lang')) {
  case 'ja':
    $.extend($.fn.datepicker.defaults, {
      language: $('html').attr('lang'),
    })
    break
  case 'zh':
    $.extend($.fn.datepicker.defaults, {
      language: 'zh-CN',
    })
    break
  default:
    $.extend($.fn.datepicker.defaults, {
      language: 'en',
    })
}
